import { SentimentReportTypeEnum } from '../../../common/enum/sentiment/sentiment-report-type.enum';

export interface SentimentReportScore {
  score: string;
  count: Number;
  percentageOfTotal: string;
  type: SentimentReportTypeEnum;
  date: String;
}
